









































import { computed, defineComponent } from '@vue/composition-api';
import VehicleAccordion from '@/components/Comparison/VehicleAccordion.vue';
import VehicleEmptyRow from '@/components/Comparison/VehicleEmptyRow.vue';
import VehiclePropRow from '@/components/Comparison/VehiclePropRow.vue';
import { useStore } from '@/store';
import { ActionTypes } from '@/store/actions';
import LinkRow from '@/components/Comparison/LinkRow.vue';

export default defineComponent({
    name: 'TechSpecSection',
    components: { LinkRow, VehicleAccordion, VehiclePropRow, VehicleEmptyRow },
    setup () {
        const store = useStore();
        const enginePower = computed(() => store.getters.visibleValuesOf(store.state.enginePower));
        const acceleration = computed(() => store.getters.visibleValuesOf(store.state.acceleration));
        const topSpeed = computed(() => store.getters.visibleValuesOf(store.state.topSpeed));
        const fuelConsumption = computed(() => store.getters.visibleValuesOf(store.state.fuelConsumption));
        const fuelTankCapacity = computed(() => store.getters.visibleValuesOf(store.state.fuelTankCapacity));
        const combinedRange = computed(() => store.getters.visibleValuesOf(store.state.combinedRange));
        const co2Emissions = computed(() => store.getters.visibleValuesOf(store.state.co2Emissions));
        const numberOfSeats = computed(() => store.getters.visibleValuesOf(store.state.numberOfSeats));
        const length = computed(() => store.getters.visibleValuesOf(store.state.length));
        const width = computed(() => store.getters.visibleValuesOf(store.state.width));
        const height = computed(() => store.getters.visibleValuesOf(store.state.height));
        const weight = computed(() => store.getters.visibleValuesOf(store.state.weight));
        const luggage = computed(() => store.getters.visibleValuesOf(store.state.luggage));
        const wheelType = computed(() => store.getters.visibleValuesOf(store.state.wheelType));
        const loadHeight = computed(() => store.getters.visibleValuesOf(store.state.loadHeight));
        const loadLength = computed(() => store.getters.visibleValuesOf(store.state.loadLength));
        const payload = computed(() => store.getters.visibleValuesOf(store.state.payload));
        const towingWeight = computed(() => store.getters.visibleValuesOf(store.state.towingWeight));
        const hasVan = computed(() => {
            const values = store.state.isVan;
            for (const i in values) {
                if (values[i]) {
                    return true;
                }
            }
            return false;
        });

        const hasIncludedOptions = computed(() => store.getters.valuesOfIgnoreShowDiff(store.state.hasIncludedOptions));
        const openIncludedOptionsModal = index => {
            store.dispatch(ActionTypes.OpenIncludedOptionsModal, index);
        };

        const isOpened = computed(() => store.state.menuTechSpecOpened);
        const toggleAccordion = () => {
            store.dispatch(ActionTypes.SetIsMenuTechSpecOpened, !isOpened.value);
        };
        const isEmptySection = computed(() => store.state.isEmptyTechSpec);

        return {
            enginePower,
            acceleration,
            topSpeed,
            fuelConsumption,
            fuelTankCapacity,
            combinedRange,
            co2Emissions,
            numberOfSeats,
            length,
            width,
            height,
            weight,
            luggage,
            wheelType,
            loadHeight,
            loadLength,
            payload,
            towingWeight,
            isOpened,
            toggleAccordion,
            hasVan,
            isEmptySection,
            hasIncludedOptions,
            openIncludedOptionsModal
        };
    }
});
